require('./MortgageRequestMovingExpensesRejectedView.scss');

// @ vendors
const React = require('react');

// @ helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKLink } = require('commonsComponents/OKLink');

const MortgageRequestMovingExpensesRejectedView = () => {

    const mappingBreadcrumb = [
        {
            text: formatText('navbar-loans'),
            url: '/myprofile/loans-mortgages'
        },
        {
            text: formatText('mortgageRequestPresentation-title'),
            url: '/myprofile/mortgage/panel'
        },
        {
            text: formatText('mortgageRequestMovingExpenses-breadcrumbName'),
            url: ''
        }
    ]


    return (
        <div className="grid-view">
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('mortgageRequestMovingExpensesSuccessView-mortgageRequestMovingExpensesSuccessView_title')}
                        />
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="col-xs-8 col-xs-offset-2">
                            <ContentBox>
                                <i className="mortgage-request-moving-expenses-rejected__icon-success" />
                                <div className="mortgage-request-moving-expenses-rejected">
                                    <OKBoxTitle value={formatText('mortgageRequestMovingRejectedExpensesView-rejectedExpensesTitle')} />
                                    <FormattedText 
                                        value="mortgageRequestMovingRejectedExpensesView-rejectedExpensesBodyText"
                                        className="mortgage-request-moving-expenses-rejected__content"
                                    />
                                    <div className="mortgage-request-moving-expenses-rejected__links">
                                        <span className="mortgage-request-moving-expenses-rejected__links-button">
                                            <OKLink
                                                id="panelLink"
                                                modifier="inherit-styles"
                                                to="/myprofile/mortgage/panel"
                                            >
                                                <FormattedText value="mortgageRequestMovingExpensesSuccess-mortgageRequestMovingExpensesSuccess_panelLinkLabel" />
                                            </OKLink>
                                        </span>
                                    </div>
                                </div >
                            </ContentBox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

module.exports = MortgageRequestMovingExpensesRejectedView;
